import('./edge_progress_bar.css')

export default function EdgeProgressBar(opts){
    BaseConstructor.call(this)
    let context = this
    /**
     * move_factor: em milisegundos, o quanto tempo de espera entre cada reajuste da barra. default é 100 (100 milisegundos = 10 redraw em 1 segundo)
     *      para períodos muito longos, não vale a pena ficar reajustando a barra 10x por segundo (só prejudica performance,ganho visual é ZERO). Por isso essa variável deve ser utilizada
     */
    let {container, duration /*em segundos*/, move_factor = 100 ,customClass = '', options = {}, label = {}} = opts

    let interval
    let label_container
    let elements = {

    }

    this.generate = _ =>{
        elements.wrapper = document.createElement('div')
        $(elements.wrapper).css({
            position:'relative',
            display: 'flex',
            justifyContent: 'space-between'
        })
        elements.container = document.createElement('div')
        $(elements.container).addClass(`progress-bar-container ${options.size ? 'progress-bar-' + options.size : "progress-bar-sm"} ${customClass}`)
        $(elements.wrapper).html(elements.container)
        if(options.position == 'bottom'){
            $(elements.container).addClass('progress-bar-bottom')
            $(container).append(elements.wrapper)
        } else {
            $(container).prepend(elements.wrapper)
        }


        if(label.content){
            elements.label_container = document.createElement('div')
            elements.label_container.classList.add('progress-bar-label-container')
            $(elements.label_container).html(`<div class=''>${label.content}</div>`)
            $(elements.wrapper).append(elements.label_container)
        }
        
        this.setSize()
        this.setColor(options.color || '')
    }

    this.updateLabelContent = content =>{
        $(elements.label_container).html(`<div class=''>${content}</div>`)
    }

    this.move = _ =>{
        var width = 100;
        if(interval){
            this.stop()
        }
        
        interval = setInterval(frame, move_factor);
        setWidth(width)
        function frame() {
            if (width <= 0) {
                this.stop()
            } else {
                width -= 100 / ((duration*1000) / move_factor);
                setWidth(width)
            }
        }
    }

    this.stop = _ =>{
        clearInterval(interval)
        setWidth(100)
    }

    this.setDuration = seconds =>{
        duration = seconds
    }

    this.restart = seconds =>{
        if(seconds){
            this.setDuration(seconds)
        }
        this.move()
    }

    this.setColor = color =>{
        elements.container.style.backgroundColor = color
        if(label.content){
            elements.label_container.style.backgroundColor = color
        }
    }

    this.setPosition = position =>{
        $(elements.container).toggleClass('progress-bar-bottom', position == 'bottom')
    }

    this.show = boolean =>{
        $(elements.container).toggle(boolean)
    }

    this.setSize = _ =>{
        
    }


    function setWidth(width){
        elements.container.style.width = width + '%'
    }
}

    
EdgeProgressBar.prototype = Object.create(BaseConstructor.prototype)
    